import { InbodyIndicatorInfo } from '../../../../../../../interfaces/inbodyIndicator';
import { ScanRowInfo } from '../InbodyIndicatorsTableView.config';

export const getScansInfo = (
  customerInbodyIndicators: InbodyIndicatorInfo[],
): ScanRowInfo[] => {
  const scansMap: Record<number, ScanRowInfo> = {};

  customerInbodyIndicators.forEach((indicator) => {
    indicator.scans.forEach((scan) => {
      if (!scansMap[scan.scanId]) {
        scansMap[scan.scanId] = {
          scanId: scan.scanId,
          scanDateTime: scan.scanDateTime,
          indicatorValues: {
            [indicator.key]: scan.value,
          },
        };
      } else {
        scansMap[scan.scanId].indicatorValues[indicator.key] = scan.value;
      }
    });
  });

  return Object.values(scansMap);
};
